import NextLink from 'next/link';

import {
	Avatar,
	AvatarContent,
	AvatarDescription,
	AvatarFallback,
	AvatarImage,
	AvatarTitle,
} from '@playbooks/ui/components/avatar';
import { FarIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

const AccountAboutCard = ({ account, href, onClick = undefined }) => {
	const initials = account.name
		?.split(' ')
		.map(value => value[0])
		.join('')
		.slice(0, 2);
	const subscriptionName = account.subscription?.name || (account.subscription?.isPro ? 'Pro' : 'Free');
	const planName = /plan$/i.test(subscriptionName) ? subscriptionName : `${subscriptionName} plan`;

	const content = (
		<>
			<Avatar className='flex-start w-full gap-3'>
				{account.thumbnail ? (
					<AvatarImage src={account.thumbnail} className='size-9 rounded-panel' />
				) : (
					<AvatarFallback className='size-9 rounded-panel'>{initials}</AvatarFallback>
				)}
				<AvatarContent className='flex-column min-w-0 gap-0.5 text-left'>
					<AvatarTitle className='w-full text-left text-base leading-none'>{account.name}</AvatarTitle>
					<AvatarDescription className='w-full truncate text-left leading-tight'>{planName}</AvatarDescription>
				</AvatarContent>
				{onClick ? <FarIcon icon='chevron-right' className='ml-auto size-3 text-foreground-subtle' /> : null}
			</Avatar>
		</>
	);
	const className = cn(
		'group block w-full rounded-panel p-2 text-left text-foreground outline-none focus-visible:ring-3 focus-visible:ring-focus/50',
		onClick && 'hover:bg-surface-hover',
	);

	if (onClick) {
		return (
			<button type='button' className={className} onClick={onClick}>
				{content}
			</button>
		);
	}

	return (
		<NextLink href={href || account.appPath} className={className}>
			{content}
		</NextLink>
	);
};
export { AccountAboutCard };
